var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTakeFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F7",
    fillRule: "nonzero",
    d: "M13.5842142,0 C15,0 16,1.081432 16,2.5 C16,13.5744407 16,19.111661 16,19.111661 C16,19.703887 15.694087,20 15.082261,20 C6.94198596,20 2.26624301,20 0.97644761,20 C0,20 0,19.111661 0,19.111661 L0,2.5 C0,1.11915588 1.02322824,0 2.28571429,0 L13.5842142,0 Z M6,3 L2,3 L2,4 L14,4 L14,3 L10,3 L10,2 L6,2 L6,3 Z M5.14823227,11.7107392 L6.5492475,12.0579473 L6.71980588,11.8995717 C6.97970565,11.6802813 7.31878856,11.5706377 7.73706476,11.5706377 C8.19188937,11.5706377 8.54315489,11.7046465 8.79087187,11.9726681 C9.03858884,12.2406898 9.16244547,12.6264727 9.16244547,13.1300286 C9.16244547,13.653889 9.05483233,14.0589611 8.83960283,14.345257 C8.62437333,14.6315528 8.31777741,14.7746986 7.91980588,14.7746986 C7.56244368,14.7746986 7.27310648,14.6721616 7.05178557,14.4670844 C6.83046467,14.2620072 6.70153195,13.9747005 6.66498354,13.6051555 L4.92285156,13.6051555 C4.9390953,14.1087113 5.08021064,14.5574378 5.34620182,14.9513484 C5.61219299,15.3452589 5.97462592,15.6508396 6.43351146,15.8680996 C6.892397,16.0853596 7.38985396,16.1939879 7.92589725,16.1939879 C8.53909828,16.1939879 9.07107266,16.0691161 9.52183633,15.8193687 C9.97260001,15.5696212 10.3187894,15.2183557 10.560415,14.7655615 C10.8020406,14.3127674 10.9228516,13.8000822 10.9228516,13.2274905 C10.9228516,12.2853538 10.68326,11.5523662 10.2040698,11.0285057 C9.72487962,10.5046452 9.06295731,10.2427189 8.21828303,10.2427189 C7.74721469,10.2427189 7.30254909,10.3543929 6.88427288,10.5777443 L7.10356222,8.6711453 L10.6304658,8.6711453 L10.6304658,7.203125 L5.6599074,7.203125 L5.14823227,11.7107392 Z",
    transform: "translate(8 6)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeFive);
export default __webpack_public_path__ + "static/media/take-five.0b208799.svg";
export { ForwardRef as ReactComponent };